import { render, staticRenderFns } from "./StagesEditor.vue?vue&type=template&id=63936ee7"
import script from "./StagesEditor.vue?vue&type=script&lang=js"
export * from "./StagesEditor.vue?vue&type=script&lang=js"
import style0 from "./StagesEditor.vue?vue&type=style&index=0&id=63936ee7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports